module.exports = __webpack_public_path__ + "media/svg-new/math-ad00674f.svg";